import { render } from "./BoardMembersAvatar.vue?vue&type=template&id=b03965dc&scoped=true"
import script from "./BoardMembersAvatar.vue?vue&type=script&lang=js"
export * from "./BoardMembersAvatar.vue?vue&type=script&lang=js"

import "./BoardMembersAvatar.vue?vue&type=style&index=0&id=b03965dc&scoped=true&lang=css"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b03965dc"]])

export default __exports__